import React, { useState, useEffect } from "react";
import produce from 'immer';
import auth from "../auth";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import Version from "../version";
import ServerState from '../controls/ServerState';
import ReactLoading from 'react-loading';
import { useConnect } from 'dotnetify';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { LargeButton } from '../controls/components/Buttons';
import { DatePicker, MuiPickersUtilsProvider, Calendar } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import nbLocale from "date-fns/locale/nb";
import svLocale from "date-fns/locale/sv";
import { StyledTextField } from '../controls/TextField';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function ChangePortingDate(props) {
    const { t } = useTranslation();
    const formatDate = date => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    };

    const { vm, state, setState } = useConnect("ChangePortingDate", { Options: ['09:00', '10:00'], PortingTime: '09:00', PortingDate: formatDate(new Date()) }, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        vmArg: {
            HostUrl: window.location.host,
            Path: window.location.pathname,
            SubscriptionNo: props.SubscriptionNo,
        },
        exceptionHandler: _ => auth.signOut()
    });
    const gstate = useGlobalState(globalState);
    const theme = useTheme();

    const isDateDisabled = (option) => {
        return state.DisabledTimes.includes(option);
    }

    const getDate = () => {
        var x = new Date(Date.parse(state.PortingDate));
        return x;
    }
    const handleDateChange = date => {
        var d = formatDate(date);
        setState({ PortingDate: d, PortingTime: '' });
        if (vm) {
            vm.$dispatch({ SetDate: d });
        }
    };
    const handleTouchTapDay = (event) => {
    };
    const shouldDisableDate = (date) => {
        if (date.getDay() === 0 || date.getDay() === 6) {
            return true; //Weekend
        }
        if (state.Holidays && state.Holidays.includes(formatDate(date))) {
            return true; //Red day from Sparkle Calendar
        }
        return false;
    }
    const addDays = (date, days) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const dateformat = state.IsNorway ? 'dd.MM.yyyy' : 'yyyy-MM-dd';
    const dateplace = state.IsNorway ? 'dd.mm.åååå' : 'åååå-mm-dd';

    const currentDate = new Date();
    const minDate = currentDate; // Current date
    const maxDate = addDays(currentDate, 80); // max date (+80 days (was 90))

    setTimeout(
        function () {
            props.setTitle(gstate.IsSweden.get() ? 'Ändra aktiveringsdatum' : 'Endre aktiveringssdato');
        }, 500);

    
    return (
        <>
            <ServerState serverState={state} localState={state} setLocalState={setState} handleClose={props.handleClose} handleRefresh={props.handleRefresh} />
            {state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: state.AdministratedMsisdn }) }} /></div>}
            {state.buzy &&
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50px' }} >
                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                </div>
            }
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <div style={{ fontSize: '14px', fontFamily: theme.typography.fontFamily2, maxWidth: '400px', padding: '0px 17px' }}>
                    Velg ny dag og tidspunkt under. Teknisk er det noen begrensninger ved hvor raskt man kan flytte et mobilnummer, disse begrensingene er tatt med i dine valgmuligheter for ny dag og tidspunkt.<br />
                    Alle overføringer skjer mellom klokken 09:00 og 14:00
                </div>
                <div style={{ maxWidth: '500px' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={state.IsNorway ? nbLocale : svLocale}>
                        <Calendar
                            minDate={minDate}
                            maxDate={maxDate}
                            date={getDate()}
                            autoOk={false}
                            cancelLabel={false}
                            firstDayOfWeek={1}
                            onTouchTapDay={handleTouchTapDay}
                            mode={'portrait'}
                            open={true}
                            onChange={handleDateChange}
                            shouldDisableDate={shouldDisableDate}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div>
                    <Autocomplete
                        value={state.PortingTime}
                        onChange={(event,value) => { setState({ PortingTime: value }); }}
                        id="portingTime"
                        options={state.Options}
                        getOptionDisabled={(option) => isDateDisabled(option)}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} label="Klokken" variant="outlined" />
                        )}
                    />
                </div>
                <Grid container direction="row" justifyContent="center" style={{ marginTop: '24px' }}>
                    <LargeButton onClick={() => { vm.$dispatch({ PerformChange: { date: formatDate(state.PortingDate), time: state.PortingTime } }); setState({ buzy: true }); }} disabled={state.buzy}>{state.IsNorway ? 'Godkjenn' : 'Godkänn'}</LargeButton>
                </Grid>
            </Grid>

        </>
    );
}